const Histories = () => {
  return <div>Histories</div>;
};

export default Histories;
